export enum PDPTemplate {
  PDPV2 = 'PDP V2',
  PDPV2Light = 'PDP V2 Light',
  Grill = 'ZR Grill PDP',
  NonGrillDark = 'ZR Non-Grill Dark',
  NonGrillLight = 'ZR Non-Grill Light',
  TierOne = 'Tier 1',
  TierTwo = 'Tier 2',
  TierThree = 'Tier 3',
  Default = 'default',
}
